import React from 'react'
import styled from 'styled-components'
import { Wrapper } from '@farewill/ui'
import { screenMin } from '@farewill/ui/helpers/responsive'

import HeroWithImages from 'components/HeroWithImages'
import TrustpilotSummary from 'components/TrustpilotWidget/TrustpilotSummary'
import Cta from 'components/Cta'
import { CTA_TYPES } from 'components/Cta/constants'
import { FUNERAL, PRODUCTS } from 'lib/products/constants'
import { FLOW_FUNERAL_URL } from 'config'

const data = {
  title: 'The simple, personal way to say goodbye',
  subtitle: `Arrange a direct cremation from  , with the help of our award-winning team. So you can say goodbye at a time and place that feel right.`,
  images: {
    imageLeft: 'illustrations/blob_with_urn',
    imageRight: 'illustrations/sunset',
    mobileImage: 'illustrations/blob-urn-family-sunset',
  },
  ctaLinks: [
    {
      text: 'Get a quote now',
      to: FLOW_FUNERAL_URL,
      variant: 'primary',
    },
  ],
}

const StyledWrapperTrust = styled(Wrapper)`
  text-align: left;

  ${screenMin.m`
    text-align: center;
  `}
`

interface SliceHeroProps {
  title?: string
  subtitle?: string
  phoneNumber?: string
}

const SliceHero = ({
  title,
  subtitle,
  phoneNumber,
}: SliceHeroProps): React.ReactElement => (
  <HeroWithImages
    title={title || data.title}
    subtitle={subtitle || data.subtitle}
    images={data.images}
    additionalContent={
      <>
        <Wrapper>
          {phoneNumber && (
            <Cta
              type={CTA_TYPES.TELEPHONE_NUMBER}
              text="Call us now"
              telephoneNumber={phoneNumber}
              useSwappedNumber={false}
              product={PRODUCTS[FUNERAL]}
            />
          )}
        </Wrapper>
        <StyledWrapperTrust
          margin={['M', 0, 0, 0]}
          marginFromXL={['L', 0, 0, 0]}
        >
          <TrustpilotSummary />
        </StyledWrapperTrust>
      </>
    }
  />
)

export default SliceHero
